import { render } from "./ModalElevatorSend.vue?vue&type=template&id=5ca250c4&scoped=true"
import script from "./ModalElevatorSend.vue?vue&type=script&lang=js"
export * from "./ModalElevatorSend.vue?vue&type=script&lang=js"

import "./ModalElevatorSend.vue?vue&type=style&index=0&id=5ca250c4&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca250c4"]])

export default __exports__